import { Select, SelectProps } from 'antd'
import { useMemo } from 'react'

import { useLocales } from 'src/locales'

export const GenderSelect = (props: SelectProps) => {
  const { t } = useLocales()

  const genderOptions = useMemo(
    () => [
      {
        value: 'male',
        label: t('form.male')
      },
      {
        value: 'female',
        label: t('form.female')
      },
      {
        value: 'unknown',
        label: t('form.unknown')
      }
    ],
    [t]
  )

  return (
    <Select options={genderOptions} placeholder={t('form.gender')} {...props} />
  )
}
